import React from 'react'
import { techdata } from './TechStackData'
import { Code, Layers, Server, Settings } from 'lucide-react'

export default function TechStack() {
  const getIcon = (title) => {
    switch (title.toLowerCase().trim()) {
      case 'ui/ux':
        return Layers;
      case 'frontend':
        return Code;
      case 'backend':
        return Server;
      case 'devops':
        return Settings;
      default:
        return Code;
    }
  }

  const getGradient = (index) => {
    const gradients = [
      'from-purple-500 to-pink-500',
      'from-blue-500 to-cyan-500',
      'from-green-500 to-teal-500',
      'from-orange-500 to-red-500'
    ];
    return gradients[index % gradients.length];
  }

  return (
    <section className='py-20 w-full bg-gradient-to-br from-white to-gray-50'>
      <div className="bl-container">
        {/* Header Section */}
        <div className="text-center mb-16">
          <h2 className='text-4xl md:text-5xl font-bold text-gray-900 mb-4'>
            Our Tech Stack
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Cutting-edge technologies and tools we use to build exceptional digital experiences
          </p>
        </div>

        {/* Tech Stack Grid */}
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8'>
          {techdata.map((item, index) => {
            const IconComponent = getIcon(item.title);
            const gradient = getGradient(index);
            
            return (
              <div 
                key={index} 
                className='group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100'
              >
                {/* Header with Icon */}
                <div className="flex items-center mb-6">
                  <div className={`p-3 rounded-lg bg-gradient-to-r ${gradient} text-white mr-4 group-hover:scale-110 transition-transform duration-300`}>
                    <IconComponent size={24} />
                  </div>
                  <h3 className='text-xl font-bold text-gray-900 group-hover:text-blue-600 transition-colors duration-300'>
                    {item.title}
                  </h3>
                </div>
                
                {/* Technologies List */}
                <div className='space-y-3'>
                  {item.language.map((tech, techIndex) => (
                    <div 
                      key={techIndex} 
                      className='flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-200 group-hover:bg-blue-50'
                    >
                      <div className={`w-2 h-2 rounded-full bg-gradient-to-r ${gradient} mr-3`}></div>
                      <span className='text-gray-700 font-medium'>{tech.trim()}</span>
                    </div>
                  ))}
                </div>

                {/* Experience Level Indicator */}
                <div className="mt-6 pt-4 border-t border-gray-100">
                  <div className="flex justify-between items-center text-sm text-gray-500 mb-2">
                    <span>Expertise Level</span>
                    <span>Advanced</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div className={`bg-gradient-to-r ${gradient} h-2 rounded-full transition-all duration-500 group-hover:w-full`} 
                         style={{width: '85%'}}></div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>

        {/* Call to Action */}
        {/* <div className="text-center mt-16">
          <p className="text-gray-600 mb-6">
            Want to see these technologies in action?
          </p>
          <button className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all duration-300 shadow-lg hover:shadow-xl">
            View Our Projects
            <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </button>
        </div> */}
      </div>
    </section>
  )
}
